<div class="border-collapse " >
  <button class="btn-primary" (click)="startCamera(x,y)">Start webcam</button>
  <button class="btn-primary" (click)="takePicture()">takePicture to mail</button>
  <video #videoElement autoplay ></video>
</div>
<video #video autoplay></video>
<canvas #canvas style="display: none;"></canvas>
